<template>
  <div class="row" style="height: 100%">
    <div class="col" style="border-right: 1px solid #d0d2e0; overflow-y: auto; max-height: calc(100vh - 200px)">
      <div class="flex justify-between" style="border-bottom: 1px solid #d0d2e0">
        <div class="text-h5 q-ml-md q-pa-sm" style="border-bottom: 1px solid black">
          {{ $t('label.story.popup_selection') }}
        </div>
        <div
          class="flex justify-between q-gutter-x-sm q-mr-sm"
          v-if="form.trigger_type === 'default' || form.trigger_type === 'popup_deliver'"
        >
          <div class="flex items-center">
            <label>ポップアップ:</label>
          </div>
          <div class="flex items-center">
            <q-btn-group v-if="isTestMode">
              <q-btn
                size="sm"
                :class="isAddPopup ? 'btn-save' : 'btn-save-grey'"
                @click="onIsAddPopup(true)"
                label="ON"
              />
              <q-btn
                size="sm"
                :class="!isAddPopup ? 'btn-save' : 'btn-save-grey'"
                @click="onIsAddPopup(false)"
                label="OFF"
              />
            </q-btn-group>
            <q-btn-group v-else>
              <q-btn
                size="sm"
                :class="isAddPopup ? 'btn-save' : 'btn-save-grey'"
                @click="onIsAddPopup(true)"
                label="ON"
              />
              <q-btn
                size="sm"
                :class="!isAddPopup ? 'btn-save' : 'btn-save-grey'"
                @click="onIsAddPopup(false)"
                label="OFF"
              />
            </q-btn-group>
          </div>
        </div>
      </div>
      <div class="q-mx-md q-mt-sm">配信するポップアップは、最大５つまで同時均等配信が可能です。</div>
      <div class="q-ma-md list-view">
        <PopupListView
          :appId="campaign.app_id"
          :campaignId="campaign._id"
          :popupList="popupList"
          :isTestMode="isTestMode"
          :isSetting="isSetting"
          @update:isSettingValue="(value) => (setting = value)"
          @update:addPopup="onAddPopup"
          @update:updatePopup="onUpdatePopup"
          @update:activePopup="onActivePopup"
          @update:selectedPopup="(item) => (selectedPopup = item)"
        />
      </div>
    </div>
    <div
      class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12"
      style="overflow-y: auto; max-height: calc(100vh - 200px); min-width: 450px"
    >
      <div class="flex justify-between" style="border-bottom: 1px solid #d0d2e0">
        <div class="text-h5 q-ml-md q-pa-sm" style="border-bottom: 1px solid black">
          {{ $t('label.story.line_guidance_banner') }}
        </div>
        <div style="width: 10px"></div>
      </div>
      <div class="q-ml-md q-mt-sm">
        <div class="flex items-center q-pb-sm horizontal-line">
          <div class="text-subtitle1 text-grey-8 q-mr-md">
            ページ内でポップアップを表示させる条件を設定してください。
          </div>
        </div>
        <q-expansion-item
          label="ポップアップタグ"
          v-if="campaign?._id"
          class="horizontal-line"
          header-style="font-weight: 700"
        >
          <TagCodeV2 :trackingCode="trackingCode" :tagJsUrl="campaignTagJsUrl" v-if="campaignTagJsUrl"></TagCodeV2>
        </q-expansion-item>
        <q-expansion-item label="条件設定" class="horizontal-line" header-style="font-weight: 700">
          <q-form ref="campaignForm" greedy>
            <TriggerSettingSelector v-model="campaign.test_detail.events_setting" :in-modal="false" v-if="isTestMode" />
            <TriggerSettingSelector v-model="campaign.prod_detail.events_setting" :in-modal="false" v-else />
          </q-form>
        </q-expansion-item>
        <q-expansion-item label="QRコード/URL" header-style="font-weight: 700">
          <div class="text-caption text-grey-8 q-ml-md q-mb-sm">
            選択したバナー経由でこのストーリーに遷移するQRコードとURL
          </div>
          <div class="row q-gutter-x-md q-px-lg">
            <div class="flex items-center justify-center">
              <div v-if="qrCodeUrl">
                <img :src="qrCodeUrl" width="200" style="border: 1px solid black" />
              </div>
              <div v-else class="empty-qr-code">
                ポップアップを<br />
                選択してください
              </div>
            </div>
            <div class="flex items-center justify-center">
              <div class="grid text-center gap-2">
                <div class="row">
                  <span v-if="qrCodeUrl"
                    >ID : {{ selectedPopup._id ? selectedPopup._id.slice(0, 4) + '***' : selectedPopup._id }}</span
                  >
                  <span v-else>ID : －－－－</span>
                </div>
                <div class="row" id="tabcode">
                  <q-btn
                    dense
                    unelevated
                    icon="content_copy"
                    :disable="qrCodeUrl === ''"
                    :class="qrCodeUrl === '' ? 'btn-save-grey' : 'btn-save'"
                    @click="onCopyLinkPopup"
                    style="width: 120px"
                    align="around"
                    >URLコピー
                  </q-btn>
                </div>
              </div>
            </div>
          </div>
        </q-expansion-item>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { IApp, ICampaign, IPopup, IStory } from '@/utils/types'
import { ACTION_APP, ACTION_CAMPAIGN, ACTION_POPUP } from '@/store/actions'
import { Prop, Watch } from 'vue-property-decorator'
import { constant } from '@/utils/constants'
import cloneDeep from 'lodash/cloneDeep'
import { maska } from 'maska'
import QRCode from 'qrcode'
import TagCodeV2 from '@/components/story/common/TagCodeV2.vue'
import PopupListView from '@/components/story/common/PopupListView.vue'
import TriggerSettingSelector from '@/components/campaign/selectors/TriggerSettingSelector.vue'

@Options({
  components: {
    TriggerSettingSelector,
    PopupListView,
    TagCodeV2,
  },
  directives: { maska },
  emits: ['update:modelValue', 'update:isSettingValue', 'update:onSave', 'update:onNextStep'],
})
export default class CampaignPopup extends Vue {
  @Prop({})
  modelValue!: IStory

  @Prop()
  isSetting!: boolean

  @Prop({})
  isTestMode!: boolean

  qrCodeUrl = ''
  selectingApp: IApp = {}
  popupList: IPopup[] = []

  blankPopup: IPopup = {
    _id: '',
    app_id: '',
    campaign_id: '',
    is_active: false,
    is_test_mode: false,
    display_id: '',
    popup_name: '',
    images: [],
    animation_type: constant.animation_type.fade_in,
  }

  campaign: ICampaign = {
    _id: '',
    app_id: '',
    is_active: false,
    is_test_mode: false,
    is_traffic_source: false,
    campaign_name: '',
    prod_detail: {
      is_add_popup: true,
      events_setting: {
        back_button_click: {
          is_active: true,
          force_display: true,
          seconds: 0,
        },
        mouse_out_screen: {
          is_active: true,
          seconds: 2,
        },
        after_page_loaded: {
          is_active: true,
          seconds: 50,
        },
        scroll_up: {
          is_active: true,
          position: 1,
        },
        scroll_down: {
          is_active: true,
          position: 1,
        },
        number_display_trigger: {
          is_active: true,
          number: 1,
        },
      },
    },
    test_detail: {
      is_add_popup: true,
      events_setting: {
        back_button_click: {
          is_active: true,
          force_display: true,
          seconds: 0,
        },
        mouse_out_screen: {
          is_active: true,
          seconds: 2,
        },
        after_page_loaded: {
          is_active: true,
          seconds: 50,
        },
        scroll_up: {
          is_active: true,
          position: 1,
        },
        scroll_down: {
          is_active: true,
          position: 1,
        },
        number_display_trigger: {
          is_active: true,
          number: 1,
        },
      },
    },
  }

  selectedPopup: IPopup = cloneDeep(this.blankPopup)

  get trackingCode() {
    return this.campaign._id + ';' + this.isTestMode + ';' + this.selectedAppId
  }

  get selectedAppId() {
    return this.$route.params.app_id as string
  }

  get form() {
    return this.modelValue
  }

  set form(value: IStory) {
    this.$emit('update:modelValue', value)
  }

  get setting() {
    return this.isSetting
  }

  set setting(value: boolean) {
    this.$emit('update:isSettingValue', value)
  }

  get isAddPopup() {
    if (this.isTestMode) {
      return this.form.campaign?.test_detail?.is_add_popup ?? true
    } else {
      return this.form.campaign?.prod_detail?.is_add_popup ?? true
    }
  }

  get campaignTagJsUrl(): boolean {
    return this.$store.getters.tagjsUrl
  }

  onIsAddPopup(value) {
    if (this.isTestMode) {
      this.form?.campaign?.test_detail && (this.form.campaign.test_detail.is_add_popup = value)
      this.campaign?.test_detail && (this.campaign.test_detail.is_add_popup = value)
    } else {
      this.form?.campaign?.prod_detail && (this.form.campaign.prod_detail.is_add_popup = value)
      this.campaign?.prod_detail && (this.campaign.prod_detail.is_add_popup = value)
    }
  }

  validate(isSave = false, popupData: IPopup) {
    if (this.setting) {
      this.$refs.campaignForm
        .validate()
        .then(async (success: boolean) => {
          if (!success) {
            return
          }

          this.form.campaign = this.campaign
          if (this.form.popups && popupData) {
            popupData.campaign_id = this.campaign._id
            popupData.app_id = this.campaign.app_id
            this.form.popups.push(popupData)
          }
          if (isSave) {
            this.$emit('update:onSave')
          } else {
            this.$emit('update:onNextStep')
          }
        })
        .catch((error: unknown) => {
          console.log('error', error)
        })
    } else {
      this.$q.dialog({
        title: this.$t('error'),
        message: this.$t('messages.please_add_popup'),
        persistent: true,
        html: true,
      })
    }
  }

  @Watch('selectedPopup', { immediate: true })
  async onChangePopupName() {
    this.qrCodeUrl = ''
    this.selectedPopup.redirect_url = this.getTrackingURL()
    if (this.selectedPopup.redirect_url) {
      this.qrCodeUrl = await QRCode.toDataURL(this.selectedPopup.redirect_url, {
        errorCorrectionLevel: 'H',
        width: 200, // generate with a bigger width
      })
    }
  }

  getTrackingURL() {
    if (this.selectedPopup.popup_name === '') {
      return ''
    }

    let accountId = this.selectingApp.account_id
    let liffId = this.selectingApp.liff_id
    if (this.isTestMode) {
      accountId = this.selectingApp.account_id_test
      liffId = this.selectingApp.liff_id_test
    }

    let url = ''
    if (this.form.trigger_type === 'popup_deliver') {
      const params = encodeURIComponent(
        `account_id=${accountId}&liff_id=${liffId}&is_test_mode=${this.isTestMode}&story_id=${this.form._id}&campaign_id=${this.form.campaign?._id}&popup_id=${this.selectedPopup._id}&source_id=${this.selectedPopup._id}`
      )
      url = `https://liff.line.me/${liffId}?${params}`
    } else {
      url = `https://line.me/R/ti/p/@${accountId}`
    }

    return url
  }

  async onAddPopup(popup: IPopup) {
    this.validate(true, popup)
  }

  async onUpdatePopup(popup: IPopup) {
    const { dispatch } = this.$store
    let item = null
    item = await dispatch(ACTION_POPUP.UPDATE, {
      _id: popup._id,
      ...popup,
    })

    if (item) {
      if (this.form.popups) {
        const existingPopup = this.form.popups.find((item) => item._id === popup._id)
        if (existingPopup) {
          Object.assign(existingPopup, popup)
        }
      }
      this.$q.notify({
        message: this.$t('messages.saved'),
        color: 'positive',
      })
    }
  }

  async onActivePopup(popup: IPopup) {
    await this.updateStatusMode(popup, this.isTestMode)
  }

  async onCopyLinkPopup() {
    const textToCopy = this.selectedPopup.redirect_url ?? ''
    try {
      await navigator.clipboard.writeText(textToCopy)
      this.tagCopySuccess()
    } catch (err) {
      console.error('Failed to copy text: ', err)
    }
  }

  tagCopySuccess(): void {
    this.$q.notify({
      message: this.$t('label.copied'),
      color: 'positive',
    })
  }

  async updateStatusMode(item: IPopup, statusMode) {
    let mod = ACTION_POPUP.IS_ACTIVE
    if (statusMode) {
      mod = ACTION_POPUP.TEST_MODE
    }
    const isSuccess = await this.$store.dispatch(mod, item)
    if (isSuccess) {
      if (this.form.popups) {
        const existingPopup = this.form.popups.find((p) => p._id === item._id)
        if (existingPopup) {
          Object.assign(existingPopup, item)
        }
      }

      this.$q.notify({
        message: this.$t('messages.saved'),
        color: 'positive',
      })
    }

    return isSuccess
  }

  async created() {
    this.selectingApp = await this.$store.dispatch(ACTION_APP.LOAD_ITEM, this.selectedAppId)
    await this.$store.dispatch(ACTION_CAMPAIGN.LOADED_TAG_JS)
    if (this.form._id) {
      this.campaign = { ...this.campaign, ...cloneDeep(this.form.campaign) }
      if (this.campaign.prod_detail && !this.campaign.prod_detail?.events_setting) {
        this.campaign.prod_detail.events_setting = {
          back_button_click: {
            is_active: true,
            force_display: true,
            seconds: 0,
          },
          mouse_out_screen: {
            is_active: true,
            seconds: 2,
          },
          after_page_loaded: {
            is_active: true,
            seconds: 50,
          },
          scroll_up: {
            is_active: true,
            position: 1,
          },
          scroll_down: {
            is_active: true,
            position: 1,
          },
          number_display_trigger: {
            is_active: true,
            number: 1,
          },
        }
      }
      if (this.campaign.test_detail && !this.campaign.test_detail?.events_setting) {
        this.campaign.test_detail.events_setting = {
          back_button_click: {
            is_active: true,
            force_display: true,
            seconds: 0,
          },
          mouse_out_screen: {
            is_active: true,
            seconds: 2,
          },
          after_page_loaded: {
            is_active: true,
            seconds: 50,
          },
          scroll_up: {
            is_active: true,
            position: 1,
          },
          scroll_down: {
            is_active: true,
            position: 1,
          },
          number_display_trigger: {
            is_active: true,
            number: 1,
          },
        }
      }
      this.popupList = this.form.popups ?? []
    }
  }
}
</script>

<style scoped lang="scss">
.q-field--with-bottom {
  padding-bottom: 0;
}
.q-field--with-bottom:has(.text-negative) {
  padding-bottom: 20px;
}
.empty-qr-code {
  width: 200px;
  height: 200px;
  border: 1px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 8px;
  margin-bottom: 4px;
}
:deep(.q-btn__content i.q-icon) {
  margin-right: 4px;
}
</style>
